export class StoreKeeper {
  public static store: any;
}
